import React from "react";

const variants = {
  primary: {
    padding: "var(--sp-2) var(--sp-5)",
    background: "linear-gradient(135deg, var(--gold2), var(--gold3))",
    border: "none",
    borderRadius: "var(--sp-2)",
    color: "#fff",
    fontSize: 13,
    fontWeight: 700,
    fontFamily: "'Outfit', sans-serif",
    boxShadow: "0 2px 12px var(--gglow)",
  },
  outline: {
    padding: "var(--sp-2) var(--sp-4)",
    background: "var(--bg2)",
    border: "1px solid var(--bdr)",
    borderRadius: "var(--sp-2)",
    color: "var(--t2)",
    fontSize: 12,
    fontWeight: 500,
    fontFamily: "'Outfit', sans-serif",
  },
  danger: {
    padding: "var(--sp-1) var(--sp-3)",
    background: "var(--red-d)",
    border: "1px solid rgba(239,68,68,0.2)",
    borderRadius: 6,
    color: "var(--red)",
    fontSize: 11,
    fontWeight: 600,
    fontFamily: "'Outfit', sans-serif",
  },
};

export default function Button({ children, variant = "primary", disabled, loading, style = {}, ...props }) {
  const base = variants[variant] || variants.primary;
  return (
    <button
      disabled={disabled || loading}
      style={{
        ...base,
        cursor: disabled || loading ? "not-allowed" : "pointer",
        opacity: disabled || loading ? 0.7 : 1,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 8,
        ...style,
      }}
      {...props}
    >
      {loading ? (
        <>
          <span
            style={{
              width: 14,
              height: 14,
              border: "2px solid currentColor",
              borderTopColor: "transparent",
              borderRadius: "50%",
              animation: "spin 0.6s linear infinite",
            }}
          />
          Saving...
        </>
      ) : (
        children
      )}
    </button>
  );
}
